import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
import { useStateInRef } from 'seagull';
export const WEB_APPLE_SDK_LOAD_FAILED = 'SDK_LOAD_FAILED';
export const noopBiometricService = {
    getStatus: async ()=>({
            offerLogin: false,
            canEnroll: false,
            setupNeeded: false,
            enrolled: false,
            nudgeDismissed: false
        }),
    onStatusChange: async ()=>()=>{},
    claimAutoLogin: async ()=>false,
    signIn: async ()=>({
            status: 'aborted'
        }),
    enroll: async ()=>'failed',
    disable: async ()=>{},
    dismissNudge: async ()=>{},
    openEnrollmentSettings: async ()=>{},
    reconcileEnrolledIdentity: async ()=>{},
    invalidateOnStaleToken: async ()=>{},
    onAuthTokenWritten: ()=>{}
};
export const inertNativeSlots = {
    googleAuth: {
        signIn: ()=>Promise.reject(new Error('native.googleAuth.signIn not configured'))
    },
    appleAuth: {
        signIn: ()=>Promise.reject(new Error('native.appleAuth.signIn not configured'))
    },
    biometric: noopBiometricService,
    session: {
        setJustLoggedOut: async ()=>{}
    },
    boot: {
        markBundleAlive: ()=>{},
        markBooted: ()=>{},
        markFailed: ()=>{},
        get outcome () {
            return 'pending';
        }
    },
    ota: {
        whenFirstLaunchUpdateSettled: ()=>Promise.resolve()
    },
    splashScreen: {
        show: async ()=>{}
    },
    systemBrowser: {
        runOAuthRedirectFlow: ()=>Promise.resolve({
                kind: 'canceled'
            }),
        openExternalUrl: async ()=>false
    },
    locale: {
        persist: async ()=>{}
    },
    store: {
        open: async ()=>{}
    },
    push: {
        isAvailable: false,
        requestPermissionAndRegister: async ()=>'unavailable',
        registerTokenListener: async ()=>async ()=>{}
    },
    files: {
        isAvailable: false,
        save: async ()=>'unavailable'
    },
    lifecycle: {
        registerResumeListener: ()=>()=>{}
    }
};
export const inertNativeBridge = _object_spread({
    isNative: false,
    platform: 'web',
    androidCallbackScheme: null,
    updateRequired: false
}, inertNativeSlots);
export const inertNewTabHandle = {
    close: ()=>{},
    isClosed: ()=>true
};
const Context = /*#__PURE__*/ createContext(null);
export function IoContextProvider(props) {
    const getProps = useStateInRef(props);
    const value = useMemo(()=>{
        const _getProps = getProps(), { children: _ } = _getProps, rest = _object_without_properties(_getProps, [
            "children"
        ]);
        return rest;
    }, []);
    return /*#__PURE__*/ _jsx(Context.Provider, {
        value: value,
        children: props.children
    });
}
export const useIoContext = ()=>{
    const io = useContext(Context);
    if (io == null) {
        throw new Error('useIoContext must be used within IoContextProvider');
    }
    return io;
};
export default IoContextProvider;
